module.exports = __webpack_public_path__ + "img/max-performance-phone.6c5ed635.png";